import React, { useState } from 'react';
import "./Password_tab_content.css";
import { Form } from 'react-bootstrap';
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Proceed_btn from '../../../../common_components/common_btn/proceed_btn/Proceed_btn';
import Successfull_horizontal_Modal from '../../../../common_components/common_modal/successfull_horizontal_Modal/Successfull_horizontal_Modal';
import Success_horozontal_Lottie from '../../../../animations/success_horozontal_Lottie/Success_horozontal_Lottie';

function Password_tab_content() {
  const [phone, setPhone] = useState('');
  const [modalShow, setModalShow] = React.useState(false);

  return (
    <>
      <section className='Personal_details_tab_content Password_tab_content'>
        <div className="profile_form_holder">
          <Form>
            <div className="row">
              <div className="col-12">
                <div className="edit_icon_holder">
                  <FontAwesomeIcon className='edit_icon' icon={faPenToSquare} />
                </div>
              </div>

              <div className="col-md-12">
                <Form.Group className="mb-3">
                  <Form.Label>Your Current Password</Form.Label>
                  <Form.Control type="text" placeholder="Enter Your Current Password" />
                </Form.Group>
              </div>

              <div className="col-md-12">
                <Form.Group className="mb-3">
                  <Form.Label>Your New Password</Form.Label>
                  <Form.Control type="text" placeholder="Enter Your New Password" />
                </Form.Group>
              </div>



              <div className="col-12  mt-5">
                <div className="btn_holder">

                  <Proceed_btn btnText="Save Changes" className={"save_changes_btn"} onClick={() => setModalShow(true)} />
                  <Proceed_btn btnText="Cancle" className={"cancle_btn"} onClick={() => setModalShow(true)} />
                </div>

              </div>
            </div>
          </Form>
        </div>
      </section>

      <Successfull_horizontal_Modal
        show={modalShow}
        message=" Password Updated!  "
        subMessage="Your details have been saved successfully."
        onHide={() => setModalShow(false)}
        lottie={<Success_horozontal_Lottie />}
      />
    </>
  );
}

export default Password_tab_content;
